import React, {useState, useEffect} from 'react';
import {useParams, useLocation} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const OfferShowComponent = (props) => {

  const {t} = props;
  const {action, id} = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [statusDict, setStatusDict] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/dictionary/offer-status', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setStatusDict(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    if (id && action === 'read') {
      setLoading(true);
      apiCall('get', '/api/v2/offer/' + id)
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderOfferShow, id, location.search])

  return (
    <div className={"offer-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="status">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {formData.status
                ? (Array.isArray(statusDict)
                    ? statusDict.find(item => item.key === formData.status)?.value || formData.status
                    : formData.status)
                : ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="offer_number">{t('columnProjectNumber2')}</label>
            <span className="p-d-block fake-input">
              {formData.offer_number}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName')}</label>
            <span className="p-d-block fake-input">
              {formData.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="project_type">{t('columnProjectType')}</label>
            <span className="p-d-block fake-input">
              {formData?.project_type?.name || formData.project_type_name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-3"}>
          <div className="p-field p-fluid">
            <label htmlFor="currency">{t('columnCurrency')}</label>
            <span className="p-d-block fake-input">
              {formData.currency}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="partner">{t('columnPartner')}</label>
            <span className="p-d-block fake-input">
              {formData?.partner?.name || formData.partner_name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="partner_contact">{t('fieldPartnerContact')}</label>
            <span className="p-d-block fake-input">
              {formData?.partner_contact?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="company">{t('columnCompany')}</label>
            <span className="p-d-block fake-input">
              {formData?.company?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="company_contact">{t('fieldCompanyContact')}</label>
            <span className="p-d-block fake-input">
              {formData?.company_contact?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_at">{t('offerSent')}</label>
            <span className="p-d-block fake-input">
              {formData.sent_at
                  ? window.App.formatDateValue(formData.sent_at)
                  : formData.id
                    ? <span style={{opacity: 0.5, fontWeight: 'normal', fontSize: '0.9rem'}}>{t('offerNotSentYet')}</span>
                    : ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="valid_until">{t('columnValid')}</label>
            <span className="p-d-block fake-input">
              {formData.valid_until ? window.App.formatDateValue(formData.valid_until) : ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="note">{t('offerTextDescription')}</label>
            <div className="p-d-block fake-input offer-note" 
              dangerouslySetInnerHTML={{ __html: formData.note || '' }}>
            </div>
          </div>
        </div>
        <div className={"p-col-12 p-lg-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="internal_note">{t('offerInternalNote')}</label>
            <div className="p-d-block fake-input" style={{whiteSpace: 'pre-wrap'}}>
              {formData.internal_note || ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(OfferShowComponent);
